/*jshint esversion: 6 */
"use strict";

var safe_buffer = require('safe-buffer').Buffer
var uuidv4 = require('uuid').v4;
var axios = require('axios').default

export default {
    search_array_for_key_match(nameKey, match_value, passed_array) {
        console.log(passed_array)
        if (typeof passed_array !== 'object' || !passed_array.length) {
            return new error('search_array_for_key_match requires an array')
        }

        let count_number_of_matches = 0
        let matches = []
        passed_array.forEach(element, index, the_array => {
            console.log(element)
            if (element[nameKey] && element[nameKey] === match_value) {
                matches.push(element[nameKey])
                count_number_of_matches++
            }
        });

        return matches
    },
    toTitleCase(str) {
        return str.replace(
            /\w\S*/g,
            function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
    },
    merge_array_of_objects: function (original, newdata, selector = 'key') {
        newdata.forEach(dat => {
            const foundIndex = original.findIndex(ori => ori[selector] == dat[selector]);
            if (foundIndex >= 0) original.splice(foundIndex, 1, dat);
            else original.push(dat);
        });
    
        return original;
    },
    publish_message_pubsub: function (google_project_id, pub_sub_contents, pub_sub_topic, callback_function, pubsubClient, PubSub, safe_buffer) {

        //DOCS
        /*
        function log_pubsub_error(result) {
            if(result && result.status === false) {
                console.log('write_tracking_data_to_webjs write to pubsub error:');
                console.log(result);
            }
        }

        var bigquery_insert_webjs_event = {
            project_id: 'smiling-garden-126003', //Before live do twice clientGooogleProjectID & main
            dataset: 'analytics',
            table: 'webjs',
            data: res.locals.tracking_pixel_data,
            callback_webhook: null //in future have some sort of callback url POST https://url.com/  {status: true,message: here}
        };

        helpers.publish_message_pubsub(bigquery_insert_webjs_event,'bigquery_insert',log_pubsub_error);

        var iterable_sms_message_type_optin = {
            client_id: res.locals.event_data.current_client_id,
            api_method: "POST",
            api_endpoint: "users/updateSubscriptions",
            iterable_json: {
                email: res.locals.user_data.email || null,
                userId: res.locals.user_data.global_uuid || null,
                subscribedMessageTypeIds: [
                    parseInt(res.locals.iterable_sms_message_type) //fdp is 35134
                ]
            }
        }

        //send to pub sub
        helpers.publish_message_pubsub(iterable_sms_message_type_optin, 'iterable_api', pub_sub_callback);

        var send_to_twilio_number_verify_object = {
            current_client_id: current_client_id, //this is used in iterable_api_pubsub_proxy which has iterable api keys
            client_google_project_id: client_google_project_id + '',
            user_data: user_data,
            callback: null
        }

        //send to pubsub
        console.log('send to twilio pubsub: ' + JSON.stringify(send_to_twilio_number_verify_object))

        helpers.publish_message_pubsub(google_project_id,write_these_rows_send_to_pubsub,'insert_to_spanner',log_pubsub_error,pubsubClient,PubSub,safe_buffer); //could allow for async returns in future



        */

        if (!google_project_id || !pub_sub_contents || !pub_sub_topic) {
            if (!callback_function || callback_function === undefined) {
                return
            } else {
                callback_function({ status: false, message: 'missing required publish_message_pubsub function params' });
            }
        }

        if (typeof pub_sub_contents !== 'object' || pub_sub_contents === null) {
            if (!callback_function || callback_function === undefined) {
                return
            } else {
                callback_function({ status: false, message: 'pub_sub_contents param for publish_message_pubsub function must be a javascript object, not yet stringified' });
            }
        }

        //TODO test this pooling detection
        //is there a pooled one already
        try {
            if (!pubsubClient || !google_project_id === '') {
                pubsubClient = new PubSub({ google_project_id });
            }
        } catch (e) {
            console.log(e)
            if (!google_project_id) {
                let google_project_id = ''
                pubsubClient = new PubSub({ google_project_id });
            } else {
                pubsubClient = new PubSub({ google_project_id });
            }
        }

        try {
            var pubsubeventdata;
            try {
                pubsubeventdata = JSON.stringify(pub_sub_contents);
            } catch (e) {
                console.log(e)
                if (callback_function && callback_function !== undefined) {
                    return callback_function({ status: false, message: 'pub_sub_contents param for publish_message_pubsub function did not json stringify: ' + e });
                }
            }

            pubsubClient
                .topic(pub_sub_topic)
                .publish(safe_buffer.from(pubsubeventdata))
                .then(messageId => {
                    //console.log(`pubsub message ${messageId} published.`);
                    if (callback_function && callback_function !== undefined) {
                        callback_function({ status: true, message: messageId });
                    }
                })
                .catch(err => {
                    console.error('ERROR:', err);
                    if (callback_function && callback_function !== undefined) {
                        callback_function({ status: false, message: err });
                    }
                }); // end pubsubClient event*/
        } catch (e) {
            console.log('pub sub error inside publish_message_pubsub function');
            console.log(e);
            if (callback_function && callback_function !== undefined) {
                var pub_sub_callback = { status: false, message: e };
                callback_function(pub_sub_callback);
            }
        }

    },//publish_message_pubsub
    /*
    twilio: function () {

        var twilio_session = { status: false, twilio: null, twilio_client: null };
        try {
            if (process.env.TWILIO_SID && process.env.TWILIO_AUTH) {
                //console.log("MEMCACHE_URL: " + process.env.MEMCACHE_URL);
                twilio_session.status = true;
                var twilio_sid = process.env.TWILIO_SID; // Your Account SID from www.twilio.com/console
                var twilio_auth = process.env.TWILIO_AUTH;   // Your Auth Token from www.twilio.com/console

                twilio_session.twilio = require('twilio');
                twilio_session.twilio_client = new twilio_session.twilio(twilio_sid, twilio_auth);

            } else {
                twilio_session.status = false;
            }
        } catch (e) {
            console.log(e);
        }

        return twilio_session;
    },
    send_twilio_sms: function (twilio_session, the_sms_message, media_url, twilio_to, twilio_from, twilio_params) {
        var send_twilio_sms_response = { status: false, content: null };

        //format the number, then do the next step function callback
        //TODO move this to a parent function
        function format_twilio_number(twilio_session, original_number, return_function) {
            var return_formatted_number = { status: false, content: null };
            twilio_session.twilio_client.lookups.phoneNumbers(original_number)
                .fetch({ countryCode: 'US' })
                .then(phone_number => {
                    console.log('return twilio formated number:');
                    console.log(phone_number);
                    console.log(phone_number.phoneNumber);

                    return_formatted_number.status = true;
                    return_formatted_number.content = phone_number.phoneNumber;

                    return return_function(return_formatted_number);

                }, err => {
                    console.log('twilio lookup format number error');
                    return_formatted_number.status = false;
                    return_formatted_number.content = err;
                    console.log(err);
                    return return_function(return_formatted_number);
                });
        }//format_twilio_number

        function got_twilio_format_number_return_function(return_formatted_number) {
            //return_formatted_number.content === formatted number

            console.log(return_formatted_number);
            if (return_formatted_number.status === true) {
                //does this wait for twilio_session if original status is false? need to move into function and call?
                //send the sms
                let the_sms_body_object = {
                    body: the_sms_message.toString(),
                    from: twilio_from,
                    to: return_formatted_number.content
                }
                //if has image
                if (media_url && media_url !== undefined && media_url !== null & media_url !== '') {
                    the_sms_body_object.mediaUrl = media_url.toString()
                }

                //send it
                twilio_session.twilio_client.messages
                    .create(the_sms_body_object)
                then(function (execution) {

                    console.log(execution);

                    trigger_twilio_flow_response.status = true;
                    trigger_twilio_flow_response.content = execution;
                    return trigger_twilio_flow_response;

                }).catch(function (error) {
                    console.log('twilio flow fail');
                    console.log(error);
                });
            } else {
                console.log('twilio format twilio_to false');
                trigger_twilio_flow_response.status = false;
                trigger_twilio_flow_response.content = 'twilio format twilio_to false';
                return trigger_twilio_flow_response;
            }
        }//got_twilio_format_number_return_function



        //START
        if (!twilio_session || !the_sms_message || !twilio_to || !twilio_from || !twilio_params) {
            //twilio_params is {object:true} that is JSON.stringify able
            console.log('twilio-helpers send_twilio_sms missing function passed vars');
            trigger_twilio_flow_response.status = false;
            trigger_twilio_flow_response.content = 'missing passed params';
            return trigger_twilio_flow_response;
        } else {

            //check if twilio session
            if (twilio_session.status !== true) {
                console.log('twilio_session.status false');
                console.log("try to call new twilio");
                twilio_session = module.exports.twilio();
            }

            //take next step with callback
            format_twilio_number(twilio_session, twilio_to, got_twilio_format_number_return_function);


        }//end if else passed params

    },
    trigger_twilio_flow: function (twilio_session, flow_id, twilio_to, twilio_from, twilio_params) {

        //var twilio_session = {status:false,twilio:null, twilio_client:null};



        var trigger_twilio_flow_response = { status: false, content: null };

        function format_twilio_number(twilio_session, original_number, return_function) {
            var return_formatted_number = { status: false, content: null };
            twilio_session.twilio_client.lookups.phoneNumbers(original_number)
                .fetch({ countryCode: 'US' })
                .then(phone_number => {
                    console.log('return twilio formated number:');
                    console.log(phone_number);
                    console.log(phone_number.phoneNumber);

                    return_formatted_number.status = true;
                    return_formatted_number.content = phone_number.phoneNumber;

                    return return_function(return_formatted_number);

                }, err => {
                    console.log('twilio lookup format number error');
                    return_formatted_number.status = false;
                    return_formatted_number.content = err;
                    console.log(err);
                    return return_function(return_formatted_number);
                });
        }

        function got_twilio_format_number_return_function(return_formatted_number) {
            //return_formatted_number.content === formatted number
            console.log('called return function line 70');
            console.log(return_formatted_number);
            if (return_formatted_number.status === true) {
                //does this wait for twilio_session if original status is false? need to move into function and call?
                twilio_session.twilio_client.studio.flows(flow_id).executions.create({
                    to: return_formatted_number.content, from: twilio_from, parameters: JSON.stringify(twilio_params)
                }).then(function (execution) {
                    console.log('line 70 twilio got execution');
                    console.log(execution);
                    console.log('got twilio studio.flows execution id: ' + execution.sid);
                    trigger_twilio_flow_response.status = true;
                    trigger_twilio_flow_response.content = execution;
                    return trigger_twilio_flow_response;

                }).catch(function (error) {
                    console.log('twilio flow fail');
                    console.log(error);
                });
            } else {
                console.log('twilio format twilio_to false');
                trigger_twilio_flow_response.status = false;
                trigger_twilio_flow_response.content = 'twilio format twilio_to false';
                return trigger_twilio_flow_response;
            }
        }

        if (!twilio_session || !flow_id || !twilio_to || !twilio_from || !twilio_params) {
            //twilio_params is {object:true} that is JSON.stringify able
            console.log('twilio-helpers trigger_twilio_flow missing function passed vars');
            trigger_twilio_flow_response.status = false;
            trigger_twilio_flow_response.content = 'missing passed params';
            return trigger_twilio_flow_response;
        } else {
            //just assume we format correct ourselves for now. 1905 TODO maybe in future for p2p stuff verify the from?
            //var get_formatted_number_twilio_from = format_twilio_number(twilio_session,twilio_to);


            //check if twilio session
            if (twilio_session.status !== true) {
                console.log('twilio_session.status false');
                console.log("try to call new twilio");
                twilio_session = module.exports.twilio();
            }

            //take next step with callback
            format_twilio_number(twilio_session, twilio_to, got_twilio_format_number_return_function);


        }//end if else passed params

    },
    */
    example_async_promise_loop: function () {
        let loop_of_promises = []
        var this_async_function = new Promise(function (resolve, reject) {
            some_next_step(req, res, resolve, reject);
        });

        loop_of_promises.push(this_async_function)

        Promise.allSettled(res.locals.array_async_loop_functions).then(function (result) {
            console.log(result)
        }).catch(function (err) {
            console.log(err)
        });
    },
    sort_response_status_high_low: function (a, b) {
        if (a.status < b.status) { return -1; }
        if (a.status > b.status) { return 1; }
        return 0;
    },
    take_spanner_result_array_transform_to_object_key_value: function (the_passed_array) {
        try {
            let return_this_single_object = {}

            if (!the_passed_array || the_passed_array === undefined || the_passed_array === null || !Array.isArray(the_passed_array)) {
                console.log('take_spanner_result_array_transform_to_object_key_value must pass an array: ' + the_passed_array)
                return new Error('error: take_spanner_result_array_transform_to_object_key_value must pass an array')
            }
            the_passed_array.forEach(function (item, index) {
                //console.log(item, index);
                let this_ley = item.name
                let this_value = item.value
                return_this_single_object[this_ley] = this_value
            });
            return return_this_single_object
        } catch (e) {
            return new Error('error: ' + e)
        }
    },
    parse_body_or_param_from_string_to_bool: function (the_passed_param, param_name_string, res) {
        let returned_bool_value = null
        let is_missing_post_data = false
        if (the_passed_param) {
            //console.log(the_passed_param)
            try {

                if (!param_name_string) {
                    param_name_string = 'the value passed '
                }
                if (typeof the_passed_param === "boolean") {
                    //console.log('is bool')
                    res.locals.send_response_chain.push({
                        status: 400,
                        response_type: 'json',
                        response_object: { error_message: param_name_string + " must be a string 'true' or 'false'" }
                    });
                    is_missing_post_data = true
                } else {
                    if (the_passed_param.toUpperCase() === "FALSE") {
                        returned_bool_value = false
                    } else if (the_passed_param.toUpperCase() === "TRUE") {
                        returned_bool_value = true
                    } else {
                        res.locals.send_response_chain.push({
                            status: 400,
                            response_type: 'json',
                            response_object: { error_message: param_name_string + " must be a string 'true' or 'false'" }
                        });
                        is_missing_post_data = true
                    }
                }

            } catch (e) {
                console.log(e)
                res.locals.send_response_chain.push({
                    status: 400,
                    response_type: 'json',
                    response_object: { error_message: param_name_string + " must be a string 'true' or 'false'" }
                });
                is_missing_post_data = true
            }
        } else {
            res.locals.send_response_chain.push({
                status: 400,
                response_type: 'json',
                response_object: { error_message: 'missing ' + param_name_string }
            });
            is_missing_post_data = true
        }

        return { is_missing_post_data: is_missing_post_data, returned_bool_value: returned_bool_value }
    },
    parse_incoming_data_accept_verify_type: function (incoming_data, pass_accepted_data, req, res) {
        if (!incoming_data) { return Error("need incoming_data") }

        //console.log(incoming_data)
        let return_the_data = {}


        //console.log('481 helper')
        //console.log(return_the_data)
        //how to check if required is missing?
        for (var key in pass_accepted_data) {
            if (pass_accepted_data.hasOwnProperty(key)) {
                if (pass_accepted_data[key].required === true) {

                    //console.log(key)
                    //console.log(pass_accepted_data[key])
                    //console.log(return_the_data[key])
                    //console.log(pass_accepted_data[key])
                    //console.log(pass_accepted_data[key].required)
                    if (this.return_true_if_this_passed_object_is_empty_undefined_or_empty_string(incoming_data[key])) {
                        try {
                            console.log('missing required key data ' + key)
                            console.log(pass_accepted_data[key])
                        } catch (e) {
                            console.log(e)
                        }
                        //return {error:'missing key ' + key}
                    }
                } else {
                    //console.log('not required here is the key ' + key)
                    //console.log('data: ' + incoming_data[key])
                    if (this.return_true_if_this_passed_object_is_empty_undefined_or_empty_string(incoming_data[key])) {
                        //console.log('not required but empty return?')
                        //console.log(incoming_data[key])
                        //pointless? but debug return_the_data[key] = null
                    }
                }
            }
        }


        for (var key in incoming_data) {
            if (incoming_data.hasOwnProperty(key)) {
                //console.log(key + " -> " + incoming_data[key]);
                if (pass_accepted_data[key]) {//body matches accepted key
                    //console.log(typeof incoming_data[key])
                    //console.log(incoming_data[key])

                    //nullable required

                    //doing this stupid bool because false would not parse correctly into false bool for whatever reason im tired of messing with it
                    if (pass_accepted_data[key].type === 'boolean') {//if type is bool fix it
                        ///console.log('is supposed to be boolean:')
                       // console.log(typeof incoming_data[key])

                        if (typeof incoming_data[key] === 'boolean') {
                            return_the_data[key] = incoming_data[key]
                        } else if (typeof incoming_data[key] === 'string') {
                            console.log('passed type is boolean but typeof is string try convert here')
                            console.log(incoming_data[key])
                            if (incoming_data[key].toUpperCase() === 'TRUE') {
                                return_the_data[key] = true
                                // incoming_data[key] = true 
                            } else if (incoming_data[key].toUpperCase() === 'FALSE') {
                                return_the_data[key] = false
                                // incoming_data[key] = false
                            } else {
                                return_the_data[key] = null
                            }
                        } else {
                            //console.log('should be boolean but is not bool OR string going to null it out')
                            return_the_data[key] = null
                        }

                    } else if (pass_accepted_data[key].type === 'array') {
                        //console.log('array type')
                        //console.log(incoming_data[key])
                        //console.log(typeof incoming_data[key])
                        //console.log(JSON.stringify(incoming_data[key]))
                        //console.log(incoming_data[key].length)
                        //console.log(Array.isArray(incoming_data[key]))

                        if (Array.isArray(incoming_data[key]) !== true) {
                            console.log('array needs to be an array')
                            return { error: 'key must be an array ' + key }
                        } else {
                            //return_the_data[key] = incoming_data[key]
                            return_the_data[key] = incoming_data[key]
                        }


                    } else if (pass_accepted_data[key].type === 'string') {
                       // console.log('is string 521')

                        if (typeof incoming_data[key] !== 'string') {
                            //return {error:'key must be a string ' + key}
                            //if it's null typeof is object
                            return_the_data[key] = null
                        } else {
                            //TODO null it out OR should we delete the key/value?
                            //return_the_data[key] = incoming_data[key]
                            return_the_data[key] = incoming_data[key]
                        }

                    } else if (pass_accepted_data[key].type === 'object') {

                        if (typeof incoming_data[key] !== 'object') {
                            return { error: 'key must be an array object ' + key }
                        } else {
                            //return_the_data[key] = incoming_data[key]
                            return_the_data[key] = incoming_data[key]
                        }


                    } else if (pass_accepted_data[key].type === 'int') {

                        try {
                            return_the_data[key] = parseInt(incoming_data[key])
                        } catch (e) {
                            console.log(e)
                            return_the_data[key] = null
                            //return {error:'key must be an integer ' + key}
                        }


                    } else if (pass_accepted_data[key].type === 'timestamp') {
                       // console.log(incoming_data[key])


                        if ((new Date(incoming_data[key])).getTime() > 0 !== true) {
                            return { error: 'key must be a timestamp parseable string ' + key }
                        } else {
                            return_the_data[key] = incoming_data[key]
                        }


                    } else if (pass_accepted_data[key].type ==='json') {
                        if(typeof incoming_data[key] === 'object') {
                            return_the_data[key] = JSON.stringify(incoming_data[key])
                        } else if(typeof incoming_data[key] === 'string') {
                            return_the_data[key] = incoming_data[key]
                        } else {
                            return { error: 'key must be an json or json stringifiable object ' + key }
                        }

                    } else {
                        return { error: 'there is no key.type shouldnt be here ?' }
                    }


                }
            }
        }



        return return_the_data
    },//parse_incoming_data_accept_verify_type
    return_true_if_this_passed_object_is_empty_undefined_or_empty_string: function (test_me) {
        if (typeof test_me === 'undefined' || !test_me || test_me === undefined || test_me === null || test_me === "") {
            return true
        } else {
            return false
        }
    },
    remove_null_undefined_blank_string_keys_from_object: function (obj) {
        for (var propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
                delete obj[propName];
            }
        }
        return obj
    },//remove_null_undefined_blank_string_keys_from_object
    simple_and_sql_append: function (res_locals_the_sql, the_passed_select_param, add_into_this_param_key_name, the_passed_sql_params_array) {
        try {
            if (!return_true_if_this_passed_object_is_empty_undefined_or_empty_string(the_passed_select_param)) {
                res_locals_the_sql = res_locals_the_sql + " AND " + add_into_this_param_key_name + " = @" + add_into_this_param_key_name
                the_passed_sql_params_array[add_into_this_param_key_name] = the_passed_select_param
                return {
                    res_locals_the_sql: res_locals_the_sql,
                    the_passed_sql_params_array: the_passed_sql_params_array,
                    status: true,
                    message: null
                }
            } else {
                return {
                    res_locals_the_sql: res_locals_the_sql,
                    the_passed_sql_params_array: the_passed_sql_params_array,
                    status: false,
                    message: { is_empty: true }
                }
            }
        } catch (e) {
            console.log(e)
            let response_chain_return = {
                status: 500,
                response_type: 'json',
                response_object: { error_message: e }
            }
            return {
                res_locals_the_sql: res_locals_the_sql,
                the_passed_sql_params_array: the_passed_sql_params_array,
                status: false,
                message: {
                    is_empty: true,
                    response_chain_return: response_chain_return
                }
            }

        }
    },//simple_and_sql_append
    capitalize_first_letter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    make_simple_rand_string(length,alpha,numbers,lower_only,symbols) {
        var result           = '';

        let characters = ''
        if(alpha && alpha === true) {
            if(lower_only && lower_only === true) {
                characters = characters+'abcdefghijklmnopqrstuvwxyz'
            } else {
                characters = characters+'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
            }  
        }
        if(numbers && numbers === true) {
            characters = characters+'0123456789';
        }
        if(symbols && symbols === true) {
            characters = characters+'_-~!*()' //url param safe only
        }
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
            charactersLength));
       }
       return result;
    },
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
    },
    empty_active_contact() {
        return {
            org_id: null,
            front_team_id:null,
            contact_uuid: null,
            address: null,
            cell_phone: null,
            city: null,
            contact_pulled_into_outbound_message_queue_timestamp: null,
            contact_pulled_into_outbound_message_queue_user_uuid: null,
            contact_pulled_into_queue_timestamp: null,
            contact_pulled_into_queue_user_uuid:null,
            contact_pulled_out_queue_timestamp: null,
            contact_twilio_response_timestamp:null,
            date_created:null,
            do_not_call: null,
            email: null,
            external_contact_uuid: null,
            external_contact_uuid_source: null,
            first_name:null,
            gender:null,
            is_sms_optout:true,
            json_contact_data: null,//"{}"
            last_modified:null,
            last_name: null,
            list_type:null,
            message_sid: null,
            outbound_message_status: null,
            primary_phone:null,
            sent:null,
            sent_to:null,
            state: null,
            twilio_verified_cell:null,
            
            user_uuid_created: null,
            user_uuid_last_modified:null,
            van_id:null,
            verified_cell_phone: null,
            zip:null
          }
    }

};